// @mui material components
import FormHelperText from "@mui/material/FormHelperText";
import Grid from "@mui/material/Grid";

// Material Dashboard 3 PRO React components
import MDTypography from "components/MDTypography";

import { Component } from "react";
import { connect } from "react-redux";
import {
	ADD_GOODDEAL_CITY_CHANNEL,
	DELETE_GOODDEAL_CITY_CHANNEL
} from "actions/types.js";
import { fetchSearchGooddealCityChannels } from "actions/channel";
import { bindActionCreators } from "redux";
import ReactTags from "react-tag-autocomplete";
import OrganizationChannelsField from "./OrganizationChannelsField";

class Step6 extends Component {
	sendState() {
		return this.state;
	}

	handleDelete = index => {
		const { dispatch } = this.props;

		if (index >= 0) {
			dispatch({
				type: DELETE_GOODDEAL_CITY_CHANNEL,
				index
			});
		}
	};

	handleAddition = channel => {
		const { dispatch } = this.props;
		dispatch({
			type: ADD_GOODDEAL_CITY_CHANNEL,
			value: channel
		});
	};

	onInput = query => {
		if (query?.length > 2) {
			this.props.fetchSearchGooddealCityChannels(query);
		}
	};

	render() {
		const {
			hapicity_channels,
			hapicity_channels_suggestions,
			publishedChannelErrorMsg
		} = this.props;

		return (
			<Grid container spacing={3} justifyContent="center">
				<Grid item xs={12}>
					<MDTypography variant="h6" fontWeight="light" textAlign="center">
						{
							"Veuillez sélectionner la/les villes, la/les organisation(s) où publier votre annonce sur HapiCity"
						}
					</MDTypography>
				</Grid>
				<Grid item xs={12}>
					<ReactTags
						placeholderText="Villes ..."
						tags={hapicity_channels}
						suggestions={hapicity_channels_suggestions}
						minQueryLength={3}
						maxSuggestionsLength={10}
						onDelete={this.handleDelete}
						onAddition={this.handleAddition}
						suggestionsFilter={() => true}
						onInput={this.onInput}
						removeButtonText="Cliquez pour retirer"
						inputAttributes={{
							autoComplete: "new-password"
						}}
					/>
					{publishedChannelErrorMsg && (
						<FormHelperText error>{publishedChannelErrorMsg}</FormHelperText>
					)}
				</Grid>
				<Grid item xs={12}>
					<OrganizationChannelsField communityType="City" />
				</Grid>
			</Grid>
		);
	}
}

const mapStateToProps = state => {
	const {
		isFetching,
		publishedCities,
		publishedCityErrorMsg,
		suggestions,
		hapicity_channels,
		hapicity_channels_suggestions,
		publishedChannelErrorMsg
	} = state.gooddealReducer;
	return {
		suggestions,
		publishedCities,
		publishedCityErrorMsg,
		isFetching,
		hapicity_channels: Object.values(hapicity_channels),
		hapicity_channels_suggestions: Object.values(hapicity_channels_suggestions),
		publishedChannelErrorMsg
	};
};

const mapDispatchToProps = dispatch => {
	let actions = bindActionCreators(
		{
			fetchSearchGooddealCityChannels
		},
		dispatch
	);
	return { ...actions, dispatch };
};

export default connect(mapStateToProps, mapDispatchToProps, null, {
	forwardRef: true
})(Step6);
